import React from 'react'
import './FinderDisclaimer.scss'

const FinderDisclaimer = ({ disclaimerText, additionalClasses = '' }) => (
  <div className={`FinderDisclaimer ${additionalClasses}`}>
    <p>{disclaimerText}</p>
  </div>
)

export default FinderDisclaimer
